module.exports = __webpack_public_path__ + "static/media/lavendar.0008e5f0.jpeg";